import { add, listen, qs, qsa } from "@fluorescent/dom";
import { emit, on } from "@/neon/events";

const {
  strings: { product: strings },
} = theme;

const selectors = {
  sprForm: ".spr-form",
  newReviewButton: ".spr-summary-actions-newreview",
  submitButton: ".spr-button",
  modalContent: ".modal__content",
  summery: ".spr-summary",
  starRating: ".spr-starrating",
  shopifySection: ".shopify-section",
};

export default function () {
  const sprForm = qs(selectors.sprForm, document);
  const wrappingContainer = sprForm.closest(selectors.shopifySection);
  const newReviewButton = qs(selectors.newReviewButton, document);
  const modalContent = qs(selectors.modalContent, document);
  const reviewsCaption = qs(selectors.summery, document);

  const headingStars = qs(selectors.starRating, reviewsCaption);

  // If reviews don't exist add empty stars to heading
  if (!headingStars) {
    const emptyStars = `
      <span class="spr-starrating spr-summary-starrating">
        <i class="spr-icon spr-icon-star-empty"></i>
        <i class="spr-icon spr-icon-star-empty"></i>
        <i class="spr-icon spr-icon-star-empty"></i>
        <i class="spr-icon spr-icon-star-empty"></i>
        <i class="spr-icon spr-icon-star-empty"></i>
      </span>
    `;

    reviewsCaption.insertAdjacentHTML("afterbegin", emptyStars);
  }

  // Add wrapping section classes
  if (wrappingContainer.parentNode.classList.contains("main")) {
    add(
      wrappingContainer,
      "shopify-section--stackable",
      "shopify-section--contrast"
    );

    // If last section before footer add appropriate class
    if (!wrappingContainer.nextElementSibling) {
      add(wrappingContainer, "shoping-section--contrast-before-footer");
    }
  }

  const formListener = on("spr-form:updated", handleFormUpdate);

  addNewButton();

  function handleFormUpdate() {
    const sprForm = qs(selectors.sprForm, document);
    const clonedForm = sprForm.cloneNode(true);
    modalContent.innerHTML = "";
    modalContent.appendChild(clonedForm);
  }

  function addNewButton() {
    const button = document.createElement("button");
    add(button, "spr-summary-actions-newreview", "active");
    button.innerText = strings.review;
    newReviewButton.parentNode.insertBefore(button, newReviewButton);
    listen(button, "click", e => {
      e.preventDefault();
      emit("modal:open", null, {
        modalContent: sprForm,
        narrow: true,
      });
    });
  }

  const unload = () => {
    formListener();
  };

  return { unload };
}
